// extracted by mini-css-extract-plugin
export default {"container":"f-z","wrapper":"g-z","hideCartCount":"h-z","heading":"i-z","items":"j-z","side":"k-z","checkoutWrapper":"l-z","legal":"m-z","fitNotRecommended":"n-z","fitCallout":"o-z"};